import {AdminSponsorsTable} from './AdminSponsorsTable';

export default AdminSponsorsTable;
